import { init, thumbnailDecorator, priceDecorator } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { unbindOriginalSearch, updateSearchOverlay } from "./helpers"
import { defaultConfig } from "./config"

import "./styles/index.css"

unbindOriginalSearch(".header__search-form > div[data-results]");

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    inputCssSelector: "#search",
    contentCssSelector: "#MainContent",
    // formCssSelector: "#search-form",
    dropdownCssSelector: ".header__search-form > div[data-results]",
    // hitDecorators: [
    //     priceDecorator()
    // ],
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    serpPath: '/search',
    serpPathRedirect: !location.pathname.includes("/search"),
    serpQuery: {
        products: {
            // variationId: this.variationId(),
            // currency: this.variationId(),
            fields: [
                "productId", "url", "categories",
                "name", "tags1", 
                "thumbUrl", "imageUrl", "alternateImageUrls",
                "brand", "availability", 
                "price", "listPrice", "priceCurrencyCode",
                "customFields.key", "customFields.value",
                "skus.name", "skus.price", "skus.listPrice",
                "skus.availability", "skus.id", "skus.imageUrl",
                "skus.customFields.key", "skus.customFields.value",
                "skus.inventoryLevel"
            ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    autocompleteQuery: {
        products: {
            fields: [
                "productId", "url", "categories", 
                "name", "tags1", "description",
                "thumbUrl", "imageUrl", "alternateImageUrls",
                "brand", "availability",
                "price", "listPrice", "priceCurrencyCode",
                "customFields.key", "customFields.value",
                "skus.name", "skus.price", "skus.listPrice",
                "skus.availability", "skus.id", "skus.imageUrl",
                "skus.customFields.key", "skus.customFields.value",
                "skus.inventoryLevel"
            ],
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        }
    },
    compressUrlParameters: true,
    fallback: true,
    preservePageScroll: true,
    // // Uncomment for Category Merchandising
    categoryCssSelector: '.shopify-section > section[class$="__main"]',
    categoryQuery() {
        return {
            name: 'serp',
            products: {
                fields: [
                    "productId", "url", "categories",
                    "name", "tags1", 
                    "thumbUrl", "imageUrl", "alternateImageUrls",
                    "brand", "availability",
                    "price", "listPrice", "priceCurrencyCode",
                    "customFields.key", "customFields.value",
                    "skus.name", "skus.price", "skus.listPrice",
                    "skus.availability", "skus.id", "skus.imageUrl",
                    "skus.customFields.key", "skus.customFields.value",
                    "skus.inventoryLevel"
                ],
                categoryId: this.categoryId(),
                // categoryPath: this.categoryPath(),
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },
}).then(() => { 
    updateSearchOverlay() 
})